(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nv-catalog-tools"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  if (!event.target.matches('select[name="sort_by"]')) return;
  document.querySelectorAll('.nv-catalog-tools a[href]').forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/collections/')) return;
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    link.href = url.pathname + url.search;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nv-shopping-series-menu"] && !Shopify.designMode) return;
  try {
    function fitNavauroShopPanel() {
  document.querySelectorAll('header-menu.nv-shop-disclosure').forEach((menu) => {
    const details = menu.querySelector('details');
    const panel = menu.querySelector('.nv-shop-menu__panel');
    if (!details || !details.open || !panel) return;
    const available = Math.max(0, window.innerHeight - panel.getBoundingClientRect().top - 16);
    panel.style.setProperty('--nv-menu-space', available + 'px');
  });
}
document.addEventListener('toggle', (event) => {
  if (event.target.matches('header-menu.nv-shop-disclosure > details')) requestAnimationFrame(fitNavauroShopPanel);
}, true);
window.addEventListener('resize', fitNavauroShopPanel);
document.addEventListener('pointerdown', (event) => {
  document.querySelectorAll('header-menu.nv-shop-disclosure').forEach((menu) => {
    const details = menu.querySelector('details');
    if (details && details.open && !menu.contains(event.target)) menu.close();
  });
});
  } catch(e) { console.error(e); }
})();

})();
